const normalize = (value) =>
  String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');

const extractNumbers = (value) => {
  const matches = String(value ?? '').match(/\d+(?:\.\d+)?/g);
  return matches || [];
};

const hasValueMatch = (target, candidates, { numeric = false, looseText = true } = {}) => {
  const targetText = normalize(target);
  if (!targetText) return false;

  const candidateTexts = (Array.isArray(candidates) ? candidates : [candidates])
    .map(normalize)
    .filter(Boolean);

  if (candidateTexts.some((candidate) => candidate === targetText)) return true;

  if (numeric) {
    const targetNumbers = extractNumbers(targetText);
    if (targetNumbers.length === 0) return false;
    const candidateNumbers = candidateTexts.flatMap(extractNumbers);
    return targetNumbers.some((num) => candidateNumbers.includes(num));
  }

  if (looseText && targetText.length >= 3) {
    if (candidateTexts.some((candidate) => candidate.includes(targetText) || targetText.includes(candidate))) {
      return true;
    }
  }

  return false;
};

const hasOptionalValueMatch = (target, candidates, options) => {
  const targetText = normalize(target);
  if (!targetText) return true;
  return hasValueMatch(target, candidates, options);
};

export const isBudleeContentViewerEnabledForSelection = ({
  config,
  boardValues = [],
  gradeValues = [],
  subjectValues = [],
  chapterValues = [],
  chapterData = null,
} = {}) => {
  // All curriculum content is now Budlee V2 content. V2 viewer is the universal default.
  // Respect emergency disable flag if explicitly set.
  if (config?.v2_learn_all_disabled === true) {
    return false;
  }

  // Active by default for all boards, grades, subjects, and chapters.
  return true;
};
